import { render, staticRenderFns } from "./CandidatesPayments.vue?vue&type=template&id=dd06b25c&scoped=true&lang=pug"
import script from "./CandidatesPayments.vue?vue&type=script&lang=js"
export * from "./CandidatesPayments.vue?vue&type=script&lang=js"
import style0 from "./CandidatesPayments.vue?vue&type=style&index=0&id=dd06b25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06b25c",
  null
  
)

export default component.exports